import { Directive, inject, TemplateRef } from '@angular/core';

import { MibTableSection } from './table.models';

/**
 * What the page draws at the end of every section band, handed the band's section.
 *
 * ```html
 * <ng-template mibTableSectionEnd let-section>
 *   <button mibButton mode="link" mibCellWidget (click)="showAll(section)">
 *     All cases<svg mib-icon name="arrow-right"></svg>
 *   </button>
 * </ng-template>
 * ```
 *
 * A control written there is marked `mibCellWidget`, or the table's arrow keys walk past it.
 */
@Directive({ selector: 'ng-template[mibTableSectionEnd]' })
export class MibTableSectionEndDirective {
  /** The template written by the page, drawn at the end of each band. */
  readonly template = inject<TemplateRef<{ $implicit: MibTableSection }>>(TemplateRef);
}
